import { useEffect } from 'react';
import { UI_CONSTANTS } from '../constants';

/**
 * Custom hook to auto-resize textarea based on content
 * @param {React.RefObject} textareaRef - Reference to textarea element
 * @param {string} value - Current value to watch for changes
 * @param {number} maxHeight - Maximum height in pixels
 */
export const useAutoResize = (textareaRef, value, maxHeight = UI_CONSTANTS.MAX_TEXTAREA_HEIGHT) => {
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      const newHeight = Math.min(textareaRef.current.scrollHeight, maxHeight);
      textareaRef.current.style.height = `${newHeight}px`;
    }
  }, [value, textareaRef, maxHeight]);
};
